// PillLink.tsx
import React from "react";
import { Link } from "react-router-dom";

type Props = { to?: string; children: React.ReactNode };

const classes =
  // layout
  "block w-full max-w-[560px] md:max-w-[540px] " +
  // shape & color
  "rounded-tr-2xl bg-gray-500/80 " +
  // spacing & type
  "px-5 py-3 text-forebackground text-sm leading-snug font-semibold " +
  // text style like mock
  "text-white underline underline-offset-[3px] decoration-white/70 " +
  // subtle depth
  "shadow-[inset_0_-1px_0_rgba(0,0,0,.15)] " +
  // interactions
  "hover:decoration-white transition";

const PillLink: React.FC<Props> = ({ to, children }) =>
  to ? (
    <Link to={to} target="_blank" className={classes}>
      {children}
    </Link>
  ) : (
    <span className={classes}>{children}</span>
  );

export default PillLink;
